<template>
  <f7-list form strong-ios dividers-ios outline-ios @submit.prevent="emitSubmit">
    <f7-list-input
      v-model:value.trim="ecv"
      error-message="Toto pole je povinné"
      :error-message-force="validation.ecv"
      type="text"
      label="EČV / ŠPZ"
      placeholder="Vložte EČV / ŠPZ"
      minlength="7"
      maxlength="7"
      autocapitalize="characters"
    />

    <f7-list-input
      v-model:value.trim="brand"
      type="text"
      label="Značka vozidla (nepovinné)"
      placeholder="Vložte značku"
    />

    <f7-list-input
      v-model:value.trim="model"
      type="text"
      label="Model vozidla (nepovinné)"
      placeholder="Vložte model"
    />
    <f7-block>
      <p>
        Pozn. Značka a model vozidla sa použije iba v prípade, ak sa vozidlo nepodarí nájsť vo
        verejnej databáze vozidiel Slovenskej republiky.
      </p>
    </f7-block>

    <f7-block>
      <f7-button large fill bg-color="secondary" type="submit">Pridať vozidlo</f7-button>
    </f7-block>
  </f7-list>
</template>

<script setup lang="ts">
import { inject } from 'vue'

const emit = defineEmits<{
  (e: 'submit'): void
}>()

const { ecv, brand, model, validation, validateForm } = inject<any>('formData')

const emitSubmit = () => {
  if (validateForm()) {
    emit('submit')
  }
}
</script>
